import { featured_projects as initializeBlock } from '../../blocks/featured-projects/index.js';

const runBlock = () => initializeBlock(document);

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', runBlock, { once: true });
} else {
  runBlock();
}
